import React, { Component } from 'react';
import ClosedQuestion from "./ClosedQuestion";
import OpenQuestion from "./OpenQuestion";
import GapQuestion from "./GapQuestion";

import './css/TestEditor.css';
import Header from "./Header";
import SelectQuestion from "./SelectQuestion";
import API from "../../api/API";
import StringUtils from "../../utils/StringUtils";
import ScoreUtils from '../../utils/ScoreUtils';

class TestChecker extends Component {
    constructor(props) {
        super(props);

        this.state = {
            answers: [],
            userAnswers: [],
            userScore: [],
            user_id: this.props.user_id
        };

        this.questions = this.state.questions;
    }

    componentDidMount() {
        this.loadTest();
    }

    loadTest = () => {
        API.callAPI('tests/return/?test_id=' + this.props.id + '&user_id=' + this.state.user_id)
            .then(response => {
                if (!response['error']) {
                    const scores = JSON.parse(response.scores);
                    this.setState({
                        userAnswers: JSON.parse(response.answers),
                        userScore: scores
                    }, () => {

                        API.callAPI('tests/?id=' + this.props.id)
                            .then(response => {
                                if(!response['error']) {
                                    this.questions = JSON.parse(response.test || "[]");
                                    const answers = JSON.parse(response.answers || "[]");
                                    this.setState({
                                        test_id: response.test_id,
                                        name: response.name,
                                        time: response.time,
                                        questions: this.questions,
                                        timeLeft: response.time * 60,
                                        answers: answers
                                    }, () => {
                                        if (!this.state.userScore || this.state.userScore.length !== this.state.questions.length) {
                                            this.calculateScore();
                                        }
                                    });
                                }
                            });
                    });
                }
            });

        API.callAPI('tests/return/?test_id=' + this.props.id)
            .then(response => {
                if (response['error']) return;

                this.setState({
                    tests: response
                });
            })
    };

    calculateScore = () => {
        const questions = this.state.questions;
        const scores = ScoreUtils.score(questions, this.state.answers, this.state.userAnswers);

        this.setState({ userScore: scores }, () => this.saveScore());
    };

    saveScore = () => {
        API.callAPI('tests/score/', 'PUT', {
            "test_id": this.props.id,
            "user_id": this.state.user_id,
            "scores": this.state.userScore
        });
    };

    saveCorrectAnswer = (question, answer) => {
        const answers = this.state.answers;
        answers[question] = answer;
        this.setState({ answers: answers });
    };

    saveAnswers = (question, answers) => {
        const questions = this.questions;
        questions[question].answers = answers;
        this.setState({ questions: questions });
    };

    setSubtasks = (question, subtasks) => {
        const questions = this.questions;
        questions[question].subtasks = subtasks;
        this.setState({ questions: questions });
    };

    setMultipleChoice = (question, multipleChoice) => {
        const questions = this.questions;
        questions[question].multipleChoice = multipleChoice;
        this.setState({ questions: questions });
    };

    setShuffle = (question, shuffle) => {
        const questions = this.questions;
        questions[question].shuffle = shuffle;
        this.setState({ questions: questions });
    };

    setQuestion = (questionNumber, question) => {
        const questions = this.questions;
        questions[questionNumber].question = question;
        this.setState({ questions: questions });
    };

    setHeader = (questionNumber, question) => {
        const questions = this.questions;
        questions[questionNumber].header = question;
        this.setState({ questions: questions });
    };

    setDescription = (questionNumber, description) => {
        const questions = this.questions;
        questions[questionNumber].description = description;
        this.setState({ questions: questions });
    };

    setMultiline = (questionNumber, multiline) => {
        const questions = this.questions;
        questions[questionNumber].multiline = multiline;
        this.setState({ questions: questions });
    };

    deleteQuestion = (questionNumber) => {
        const questions = this.questions;
        questions.splice(questionNumber, 1);
        const answers = this.state.answers;
        answers.splice(questionNumber, 1);
        this.setState({ questions: questions, answers: answers });
    };

    addMinute = () => {
        const timeLeft = this.state.timeLeft + 60;
        this.setState({ timeLeft: timeLeft });
    };

    removeMinute = () => {
        const timeLeft = this.state.timeLeft - 60;
        this.setState({ timeLeft: timeLeft });
    };

    selectNew = (event) => {
        this.setState({ newItem: event.target.value });
    };

    addElement = () => {
        const itemType = this.state.newItem;
        const item = {
            "uniqueId": itemType + new Date().getUTCMilliseconds(),
            "type": itemType
        };

        if (itemType === "header") {
            item.header = '';
            item.description = '';
        } else {
            item.question = '';
        }

        if (itemType === "closed") {
            item.answers = [];
            item.shuffle = false;
            item.multipleChoice = false;
        }

        if (itemType === "open") {
            item.multiline = false;
            item.points = 1;
        }

        if (itemType === "gap") {
            item.subtasks = [];
            item.words = [];
            item.shuffle = false;
        }

        if (itemType === "select") {
            item.subtasks = [];
            item.options = [];
            item.shuffle = false;
        }

        const questions = this.state.questions;
        questions.push(item);

        this.setState({ questions: questions });
    };

    move = (id, dif) => {
        const questions = this.state.questions;
        const answers = this.state.answers;

        let swap = questions[id];
        questions[id] = questions[id + dif];
        questions[id + dif] = swap;

        swap = answers[id];
        answers[id] = answers[id + dif];
        answers[id + dif] = swap;

        this.setState({ questions: questions, answers: answers });
    };

    setPoints = (id, points) => {
        const questions = this.state.questions;
        let questionPoints = points;
        if (questionPoints < 0) questionPoints = 0;
        questions[id].points = questionPoints;
        this.setState({ questions: questions })
    };

    setScore = (id, score) => {
        const scores = this.state.userScore;
        scores[id] = score;
        this.setState({ userScore: scores }, () => this.saveScore());
    };

    changeUser = (event) => {
        const userIsSure = window.confirm("Czy chcesz zapisać przed zmianą testu?");
        if (userIsSure) {
            this.saveScore();
        }

        this.setState({ user_id: event.target.value }, () => this.loadTest());
    };

    render() {
        let number = 1;
        let sum = 0;
        let max = 0;
        let questions = <div className="loader-wrapper"><div className="loader" /></div>;
        if (this.state.questions) {
            questions = this.questions.map((question, index) => {
                const task = this.createTask(question, index, number);
                if (question['type'] !== 'header') number += 1;
                const maxPoints = this.resolveMaxPoints(question);
                max += maxPoints;
                sum += Number.parseInt(this.state.userScore[index] || 0);
                return task;
            });
        }

        let users = [];
        if (this.state.tests) {
            users = this.state.tests.map(test => <option key={"user-option-" + test.user.user_id} value={test.user.user_id}>{test.user.first_name} {test.user.last_name}</option>);
        }

        return (
            <div className="test test-edit">
                <div className="toolbar">
                    <div className="toolbar-content">
                        <div className="">
                            <button className="btn-square" onClick={this.props.openList}><i className="fas fa-chevron-left"></i></button>
                        </div>
                        <div className="time">
                            <select value={this.state.user_id} onChange={this.changeUser}>
                                {users}
                            </select>
                        </div>
                        <div>{sum} / {max} = {Number.parseFloat(sum/max * 100).toFixed(2)}%</div>
                        <div className=""><button className="btn-square">Zapisz</button></div>
                    </div>
                </div>
                <div className="">
                    {questions}
                </div>
            </div>
        )
    }

    createTask(question, id, number) {
        let elementKey = "question-" + question.uniqueId;
        const isFirst = id === 0;
        const isLast = id === this.state.questions.length - 1;

        const moveUp = () => {
            this.move(id, -1);
        };

        const moveDown = () => {
            this.move(id, 1);
        };

        if (question['type'] === "closed") {
            return (
                <ClosedQuestion
                    key={elementKey}
                    id={id}
                    number={number}
                    question={question.question}
                    answers={question.answers}
                    correctAnswer={this.state.answers[id]}
                    userAnswer={this.state.userAnswers[id]}
                    multipleChoice={question.multipleChoice}
                    score={this.state.userScore[id] || 0}
                    points={question.points}
                    setScore={this.setScore}
                />)
        }

        if (question['type'] === "open") {
            return (
                <OpenQuestion
                    key={elementKey}
                    id={id}
                    number={number}
                    question={question.question}
                    answer={this.state.userAnswers[id]}
                    points={question.points}
                    score={this.state.userScore[id] || 0}
                    setScore={this.setScore}
                />)
        }

        if (question['type'] === "gap") {
            return (
                <GapQuestion
                    key={elementKey}
                    id={id}
                    number={number}
                    question={question.question}
                    subtasks={question.subtasks}
                    correctAnswer={this.state.answers[id]}
                    userAnswer={this.state.userAnswers[id]}
                    score={this.state.userScore[id] || 0}
                    points={question.points}
                    setScore={this.setScore}
                />
            );
        }

        if (question['type'] === "select") {
            return (
                <SelectQuestion
                    key={elementKey}
                    id={id}
                    number={number}
                    question={question.question}
                    subtasks={question.subtasks}
                    options={question.options}
                    shuffle={question.shuffle}
                    setQuestion={this.setQuestion}
                    deleteQuestion={this.deleteQuestion}
                    saveAnswer={this.saveCorrectAnswer}
                    points={question.points}
                    moveUp={moveUp}
                    moveDown={moveDown}
                    isFirst={isFirst}
                    isLast={isLast}
                />
            )
        }

        if (question['type'] === "header") {
            return (
                <Header
                    key={elementKey}
                    id={id}
                    header={question.header}
                    description={question.description}
                    moveUp={moveUp}
                    moveDown={moveDown}
                    isFirst={isFirst}
                    isLast={isLast}
                    setHeader={this.setHeader}
                    setDescription={this.setDescription}
                />
            );
        }
    };

    resolveMaxPoints = (question) => {
        if (question['type'] === 'open') return question.points;
        if (question['type'] === 'closed') return 1;
        if (question['type'] === 'gap') return question.subtasks.length;
        return 0;
    };
}

export default TestChecker;